<template>
    <div>
        <transition name="modal" v-if="carregando">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
                        <label>Aguarde. Carregando.</label>
                    </div>
                </div>
            </div>
        </transition>
        <div v-else>
            <div v-if="erro">
                <div v-if="flag == 0">
                    <SemPermissao></SemPermissao>
                </div>
                <div v-else>
                    <ErroAutorizacao></ErroAutorizacao>
                </div>
            </div>
            <template v-if="!erro">
                <CargoForm :cargo="cargo" />
            </template>
        </div>
    </div>
</template>

<script>
    import CargoApi from "../../services/CargoApi"
    import SemPermissao from "../SemPermissao.vue"
    //import ErroResultados from "../../components/ErroResultados";
    import CargoForm from "../../components/cargos/CargoForm.vue"
    import metaDados from "../../helpers/metaDados";

    export default {
        name: "CargoEdit",
        metaInfo() {
            if (!this.cargo) {
                return {};
            }

            let title = this.cargo.nome;
            const description = this.cargo.nome;

            return {
                titleTemplate: "%s - Casa Civil do Estado de Goiás",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        property: "description",
                        content: description,
                    },
                    {
                        vmid: "og:description",
                        property: "og:description",
                        content: description,
                    },
                    {
                        vmid: "og:title",
                        property: "og:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    {
                        vmid: "twitter:description",
                        name: "twitter:description",
                        property: "twitter:description",
                        content: description,
                    },
                    {
                        vmid: "twitter:title",
                        name: "twitter:title",
                        property: "twitter:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    ...metaDados(this.$route),
                ],
            };
        },
        data() {
            return {
                carregando: true,
                erro: false,
                flag: 0,
                cargo: null,
            };
        },
        components: {
            //ErroResultados,
            SemPermissao,
            CargoForm,
        },
        created() {
            this.CargoApi = new CargoApi();
            this.carregarCargo();
        },
        watch: {
            $route: function (to, from) {
                if (to.params.id != from.params.id) {
                    this.carregarCargo();
                }
            },
        },
        methods: {
            carregarCargo: async function () {
                try {
                    this.carregando = true;
                    this.erro = false;

                    if (this.CargoApi.cancelTokens.getCargo) {
                        this.CargoApi.cancelTokens.getCargo.cancel();
                    }

                    const dadosCargo = await this.CargoApi.getCargo(
                        this.$route.params.id
                    );
                    this.cargo = dadosCargo

                    this.carregando = false;
                } catch (err) {
                    if (this.CargoApi.isCancel(err)) {
                        return;
                    }
                    console.log(err);

                    this.erro = true;
                    this.carregando = false;
                    this.cargo = null;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
</style>